import {Injectable} from '@angular/core';
import {ApiService} from '@abstract/api.service';

/**
 * API групп элементов технического устройства
 */
@Injectable()
export class TechnicalDeviceElementsGroupApiService extends ApiService {
    baseUrl = 'technical-device-element-group';
}
